
import React, { Component } from 'react'

export default class AntonioSchiratti extends Component {
    
    render() {
        const pageCount = 47;
        const images = Array.from({ length: pageCount }, (_, i) => {
            const padded = String(i + 1).padStart(3, '0'); // ensures 001, 002, ..., 046
            return `/images/AntonioSchiratti/page${padded}.jpg`;
        });
        return (
            <div>
                <section className="zio-antonio-story" style={{ textAlign: 'center' }}>
                    <h2 style={{ margin: '1rem 0' }}>il libro su Antonio Schiratti</h2>
                    {images.map((src, index) => (
                        <div key={index} style={{ marginBottom: '2rem' }}>
                        <img 
                            src={src} 
                            alt={`Page ${index + 1}`} 
                            style={{ maxWidth: '100%', height: 'auto', boxShadow: '0 4px 12px rgba(0,0,0,0.2)' }}
                        />
                        </div>
                    ))}
                </section>           
            </div>
        )
    };
}